<h1 mat-dialog-title>{{ 'lockingTitle' | translate }}</h1>
<div mat-dialog-content>
  {{ 'lockingMessage' | translate }}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>{{ 'lockingButtonCancel' | translate }}</button>
  <button mat-button color="warn" [mat-dialog-close]="data">{{ 'lockingButtonOverride' | translate }}</button>
</div>
